import { Select, Stack, Text } from '@mantine/core';

import { ScopeComponent, SectionBlock } from '@/types';

interface SectionBlockViewProps {
  block: SectionBlock;
  onChange: (next: SectionBlock) => void;
  // Components attached to the parent ReportConfig. The slug picker shows
  // exactly these — out-of-config slugs are not selectable through the UI
  // (though they can still exist on a parsed legacy template).
  scopeComponents: ScopeComponent[];
}

export function SectionBlockView({
  block,
  onChange,
  scopeComponents,
}: Readonly<SectionBlockViewProps>) {
  const data = scopeComponents.map((sc) => ({ value: sc.slug, label: sc.name }));
  const knownSlug = scopeComponents.some((sc) => sc.slug === block.slug);

  return (
    <Stack gap={4}>
      <Select
        size="sm"
        label="Section"
        data={data}
        value={block.slug || null}
        onChange={(value) => {
          if (value) {
            onChange({ ...block, slug: value });
          }
        }}
        allowDeselect={false}
        placeholder="Pick a component"
        searchable
        nothingFoundMessage="No attached components"
      />
      {!knownSlug && block.slug && (
        <Text size="xs" c="orange">
          This section refers to a component that isn&apos;t attached to the config:{' '}
          <strong>{block.slug}</strong>. Attach it on the config page or pick a different section.
        </Text>
      )}
    </Stack>
  );
}
